<template>
  <div class="recharge-record-container">
    <!-- 查询头部 -->
    <div class="search-header">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="手机号">
          <el-input
            v-model="searchForm.phone"
            placeholder="请输入手机号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input
            v-model="searchForm.name"
            placeholder="请输入姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据表格 -->
    <el-table :data="tableData" border style="width: 100%" v-loading="loading">
      <el-table-column
        type="index"
        label="序号"
        width="60"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="CreateTime"
        label="充值时间"
        width="180"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="ExchangeTime"
        label="兑换时间"
        width="180"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="SumPrice"
        label="兑换金额"
        width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="TelPhone"
        label="兑换手机号"
        width="150"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="UserName"
        label="兑换姓名"
        width="120"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="Code"
        label="卡号"
        min-width="180"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="EnterCompanyName"
        label="录入公司"
        show-overflow-tooltip
        width="100"
      ></el-table-column>
      <el-table-column
        prop="EnterPersonName"
        label="录入人员"
        show-overflow-tooltip
        width="100"
      ></el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="float: right"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getRechargeRecordList } from "@/api/cardHolder/member";
export default {
  name: "RechargeRecord",
  props: {
    WxUserInfoId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // 搜索表单
      searchForm: {
        phone: "",
        name: "",
      },
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      // 分页信息
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    // 获取表格数据
    fetchData() {
      this.loading = true;
      const params = {
        wxUserInfoId: this.WxUserInfoId,
        page: this.pagination.currentPage,
        intPageSize: this.pagination.pageSize,
        phone: this.searchForm.phone,
        name: this.searchForm.name,
      };

      getRechargeRecordList(params)
        .then((res) => {
          console.log("获取卡片详情数据成功:", res);
          if (
            res.data &&
            res.data.success &&
            Array.isArray(res.data.response.data)
          ) {
            this.tableData = res.data.response.data || [];
            this.pagination.total = res.data.response.dataCount || 0;
          } else {
            this.$message.error(response.msg || "获取数据失败");
          }
        })
        .catch((error) => {
          console.error("获取卡片详情数据失败:", error);
          this.$message.error("获取数据失败，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 处理查询
    handleSearch() {
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    // 重置查询条件
    resetSearch() {
      this.searchForm = {
        phone: "",
        name: "",
      };
      this.handleSearch();
    },
    // 处理每页显示数量变化
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.fetchData();
    },
    // 处理页码变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.fetchData();
    },
  },
};
</script>

<style scoped>
.recharge-record-container {
  padding: 20px;
}

.search-header {
  margin-bottom: 20px;
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>
